import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';

import { Button } from '@repo/lib-design-system/primitives/button.component';
import { Stack } from '@repo/lib-design-system/primitives/stack.component';
import { cn } from '@repo/lib-design-system/utils/tw-merge.util';

export function NotFound(): ReactElement {
  const { t } = useTranslation();

  return (
    <Stack gap="2xl" align="center" className="max-w-[500px] text-center">
      <h1
        className={cn(
          'font-heading text-2xl font-semibold leading-[1.2] text-base-black',
          'dark:text-base-white'
        )}
      >
        {t('error.page.notFound.title')}
      </h1>
      <p className="text-base leading-[1.4] text-grey-600 dark:text-grey-300">
        {t('error.page.notFound.message')}
      </p>
      <Button variant="primary" asChild>
        <Link to="/">{t('error.page.notFound.home.button')}</Link>
      </Button>
    </Stack>
  );
}

export default NotFound;
